"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var contests_constants_1 = require("@biw/contests-constants");
function getProgramOverviewProps(state, program) {
    return {
        tileType: 'program-overview',
        checkingResults: false,
        calendarLabel: program.isObjectives ?
            'progress.daysToProgramStartLabel' :
            'goalSelection.toSelectGoal',
        daysLeft: program.daysLeft,
        lastDayLeftDate: program.lastDayLeftDate,
        programOverviewCode: program.isObjectives ?
            contests_constants_1.KEY_CODES.achieveyourGoalEarnRewards :
            contests_constants_1.KEY_CODES.goalrightforyou,
        buttonTextCode: program.isObjectives && !program.programHasStarted ?
            contests_constants_1.KEY_CODES.learnAboutProgram :
            contests_constants_1.KEY_CODES.selectagoal,
        footerMessageCode: program.isWaitingForProgress ?
            contests_constants_1.KEY_CODES.onyourmark :
            contests_constants_1.KEY_CODES.upforchallenge
    };
}
exports.default = getProgramOverviewProps;
//# sourceMappingURL=program-overview-props.js.map